import { createSlice } from '@reduxjs/toolkit';

import type { Organizations } from './types';

export const slice = createSlice({
    initialState: {
        isLoading: false,

        organizations: null as Organizations | null
    },

    name: 'useOrganizations',

    reducers: {
        isLoading: (state, action) => {
            state.isLoading = action.payload;
        },

        organizations: (state, action) => {
            state.organizations = action.payload;
        }
    }
});

export default slice.reducer;
